<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <section class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen objekter'" :large="true" :icon="'glyph-medium-object'"/>

      <table v-if="items.length > 0" class="large fixed sortable clickable evenodd contracts table-filter">
        <thead>
          <tr>
            <th v-for="(heading, index) in headings" v-bind:key="index" v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']" @click="changeSorting(heading.sortKey)">
              {{heading.name}}
              <span id="sorttable_sortrevind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
              <span id="sorttable_sortfwdind" v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in items" v-bind:key="item.Objektid">
            <td @click="showObjektItem($event, item)">
              <div class="flex-container">
                <span class="thumbnail-container">
                  <span class="thumbnail small">
                    <template v-if="objektThumb(item) && objektLarge(item)">
                      <img class="hi-trigger" :src="objektThumb(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                    </template>
                    <template v-else-if="objektThumb(item)">
                      <img :src="objektThumb(item)" />
                    </template>
                    <template v-else>
                      <span class="placeholder"></span>
                    </template>
                  </span>
                  <a href="javascript:;" class="primary-title">{{item.Objektnr}}</a>
                </span>
              </div>
            </td>

            <td class="show-for-small">
              {{item.Auksjon || '-'}}
            </td>

            <td class="show-for-large" @click="showObjektItem($event, item)">
              {{item.title | truncate(40)}}
              <span class="opacity-60" v-if="item.subtitle"><br>{{item.subtitle | truncate(30)}}</span>
            </td>
            <td class="show-for-large" v-if="item.Kategori" @click="showObjektItem($event, item)">
              {{item.Kategori}}
            </td>
            <td v-else>-</td>
            <td class="show-for-large">{{item.avdeling ? item.avdeling.Beskrivelse : '-'}}</td>
            <td class="show-for-medium" @click="showObjektItem($event, item)">
              <span class="opacity-60" v-if="item.Vurderingspris1>0 && item.Vurderingspris2>0">
                {{item.Vurderingspris2 | thousands}} - {{item.Vurderingspris1 | thousands}}
              </span>
              <span v-else>
                <span class="opacity-60" v-if="item.Vurderingspris1>0">
                  {{item.Vurderingspris1 | thousands}}
                </span>
                <span class="opacity-60" v-if="item.Vurderingspris2>0">
                  {{item.Vurderingspris2 | thousands}}
                </span>
              </span>
            </td>
            <td class="show-for-medium align-right" @click="showObjektItem($event, item)">
              <span class="opacity-60">
                {{item.Salgspris | thousands}}
              </span>
            </td>

            <td class="show-for-large align-right" @click="showObjektItem($event, item)">
              {{item.Fakturadato | avantidate}}
            </td>

            <td class="show-for-large align-right" @click="showObjektItem($event, item)">
              {{item.Bet_dato | avantidate}}
            </td>

            <td class="show-for-large align-right" @click="showObjektItem($event, item)">
              {{item.Lev_dato | avantidate}}
            </td>
            <td class="show-for-large align-right" @click="showUtlevPdf(item)">
              <a v-if="item.utleveringsseddel || item.Lev_dato" href="javascript:;" class="button action">
                <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-print"></use></svg>
              </a>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container"  v-if="pageCount > 1">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import KundeService from '@/services/KundeService'
import moment from 'moment'
import bus from '@/plugins/event-bus'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

export default {
  name: 'KundeCardShowTabObjekt',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      headings: [
        {name: 'Objekt', sortKey: 'Objektnr', class: ''},
        {name: 'Auksjon', sortKey: 'Auksjon', class: 'show-for-small'},
        {name: 'Tittel', sortKey: 'Tittel', class: 'show-for-large'},
        {name: 'Kategori', sortKey: 'Kategori', class: 'show-for-large'},
        {name: 'Avdeling', sortKey: 'avdeling.Beskrivelse', class: 'show-for-large'},
        {name: 'Vurdering', sortKey: 'Vurderingspris2', class: 'show-for-medium'},
        {name: 'Tilslag', sortKey: 'Salgspris', class: 'show-for-medium align-right'},
        {name: 'Fakturert', sortKey: 'Fakturadato', class: 'show-for-large align-right'},
        {name: 'Betalt', sortKey: 'Bet_dato', class: 'show-for-large align-right'},
        {name: 'Utlevert', sortKey: 'Lev_dato', class: 'show-for-large align-right'},
        {name: '', sortKey: '', class: 'unsortable show-for-large align-right'}
      ],
      loadedImages: {}
    }
  },
  created () {
    // Note: The fetch of items is done in KundeCard.
    bus.$off('export-bought-excel')

    this.currentPage = this.queryParams.page || 1
  },
  updated () {
    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {})
        }
      }

      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tootltip')

          if ($tooltipData) {
            $tooltipData = $tooltipData.substring(0, 10)
          } else {
            return
          }

          let $offsetTop = window.jQuery(this).offset().top
          let $offsetHeight = window.jQuery(this).height()
          let $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
          let $tooltipHeight = $tooltip.height() + 60

          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY + 40
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  mounted () {
    bus.$on('export-bought-excel', () => this.exportAsExcel())

    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {})
        }
      }

      // Tooltip
      if (window.jQuery('.has-tooltip') && window.jQuery('.has-tooltip').length > 0) {
        let $tooltip = window.jQuery('.tooltip')

        window.jQuery('.has-tooltip').unbind('hover')
        window.jQuery('.has-tooltip').hover(function () {
          let $tooltipData = window.jQuery(this).data('tootltip')

          if ($tooltipData) {
            $tooltipData = $tooltipData.substring(0, 10)
          } else {
            return
          }

          let $offsetTop = window.jQuery(this).offset().top
          let $offsetHeight = window.jQuery(this).height()
          let $offsetBottom = window.innerHeight - $offsetTop - $offsetHeight
          let $tooltipHeight = $tooltip.height() + 60

          $tooltip.html($tooltipData)

          // show tooltip if not already activeted
          if (!$tooltip.hasClass('active')) {
            $tooltip.addClass('active')

            window.jQuery(document).bind('mousemove', function (e) {
              $tooltip.css({
                left: e.pageX,
                top: e.pageY
              })

              if ($offsetBottom > $tooltipHeight) {
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY + 40
                })
              } else {
                // offset the tooltip if to close to bottom
                $tooltip.css({
                  left: e.pageX - 90,
                  top: e.pageY - $tooltipHeight
                })
              }
            })
          }
        },
        // hide the tooltip on blur
        function () {
          $tooltip.removeClass('active')

          window.jQuery(document).unbind('mousemove', function (e) {})
        })
      }
    })
  },
  computed: {
    ...mapGetters('kundeobjektbuyer', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  methods: {
    exportAsExcel: function () {
      if (this.pageCount < 2) {
        // Just loop current list
        bus.$emit('onExportExcel', 'exporting')

        this.makeExcel(this.items)

        bus.$emit('onExportExcel', 'submittable')
      } else {
        bus.$emit('onExportExcel', 'exporting')

        const params = this._.cloneDeep(this.queryParams)
        delete params.limit
        params.export = 1

        KundeService.getObjektWhereKundeIsBuyer(this.kunde.Kundenr, params)
          .then((response) => {
            this.makeExcel(response.data)
          })
          .catch(() => {
            this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
          })
          .then(() => {
            bus.$emit('onExportExcel', 'submittable')
          })
      }
    },
    makeExcel: function (items) {
      const fields = []
      const xarray = []

      // Get all headings in correct order...
      this.headings.forEach((item) => {
        // Skip Katalogtekst2
        fields.push(item.name)
      })

      // Push headings into data array
      xarray.push(fields)

      items.forEach((element) => {
        let vurd = ''
        if (element.Vurderingspris1 > 0 && element.Vurderingspris2 > 0) {
          vurd = Number(element.Vurderingspris2) + ' - ' + Number(element.Vurderingspris1)
        } else if (element.Vurderingspris1 > 0) {
          vurd = Number(element.Vurderingspris1)
        } else if (element.Vurderingspris2 > 0) {
          vurd = Number(element.Vurderingspris2)
        }

        const temp = [
          '="' + (element.Objektnr) + '"',
          '="' + (element.Auksjon) + '"',
          '="' + (element.title + (element.subtitle ? ' / ' + element.subtitle : '')) + '"',
          '="' + (element.Kategori) + '"',
          '="' + (element.avdeling ? element.avdeling.Beskrivelse : '-') + '"',
          '="' + (vurd) + '"',
          Number(element.Salgspris || 0),
          '="' + (this.$options.filters.avantidate(element.Fakturadato)) + '"',
          '="' + (this.$options.filters.avantidate(element.Bet_dato)) + '"',
          '="' + (this.$options.filters.avantidate(element.Lev_dato)) + '"'
        ]

        xarray.push(temp)
      })

      // Finally make csv and force download...
      const csv = '\ufeff' + Papa.unparse(xarray, { delimiter: ';' })
      const blob = new Blob([csv], {
        type: 'application/csvcharset=utf-8'
      })

      fileDownload(blob, 'kjopte-' + moment().format('DDMMYYHms') + '.csv')
    },
    showUtlevPdf: function (item) {
      if (item.utleveringsseddel) {
        console.log('Show the pdf')
        console.log(item.utleveringsseddel)
        this.openModal(
          'history-item-utleveringsseddel-pdf-modal',
          {
            objekt: item,
            item: item.utleveringsseddel,
            internalWindow: true
          },
          'split'
        )
      } else {
        this.$helpers.showErrorAlert('Utleveringsseddel', 'Ikke laget')
      }
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    objektThumbLoaded: function (item) {
      item.Fototatt = 'T'
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundeobjektbuyer/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundeobjektbuyer/reload', {
        kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },

    showObjektItem: function (event, item) {
      let isCheckboxClick = event.target.nodeName === 'INPUT'

      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      if (!isCheckboxClick) {
        this.loadObjektModal(item.Objektid)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabObjekt.vue